class ClientTermsModel {
  constructor (data) {
    this.accepted = data?.has_accepted ?? data?.accepted ?? false
    this.acceptedAt = data?.accepted_at || null
    this.termsVersion = data?.terms_version || data?.checked_version || '1.0'
    this.userId = data?.user_id || null
    this.clientId = data?.client_id || null
  }

  get isAccepted () {
    return this.accepted === true
  }

  get needsAcceptance () {
    return !this.isAccepted
  }

  get formattedAcceptedDate () {
    if (!this.acceptedAt) return null
    return new Date(this.acceptedAt).toLocaleDateString('es-CL')
  }
}

export default ClientTermsModel



// WEBPACK FOOTER //
// ./src/app/authentication/models/ClientTermsModel.js